/* ==========================================================
   HOGARIO - Product Offer v3.0
   Compatible con Shopify Dawn 15.5+

   Arquitectura:
   - OfferManager (singleton)
   - OfferCard (1 instancia por tarjeta)
   - 1 timer global
   - Compatible con variantes
   - Compatible con Quick Add
   ========================================================== */

(() => {
"use strict";

/*====================================================
=            CONFIGURACIÓN GENERAL                    =
====================================================*/

const CONFIG = {
    timezone: "America/Santiago",
    countdownHour: 23,
    countdownMinute: 59,
    countdownSecond: 59,
    stock: {
        low: 5,
        medium: 10,
        high: 20
    }
};

/*====================================================
=            UTILIDADES                               =
====================================================*/

function money(value) {

    value = Number(value || 0);

    return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
        maximumFractionDigits: 0
    }).format(value / 100);

}

function chileNow() {

    return new Date(
        new Date().toLocaleString("en-US", {
            timeZone: CONFIG.timezone
        })
    );

}

function nextSunday() {

    const now = chileNow();

    const target = new Date(now);

    let days = (7 - target.getDay()) % 7;

    if (
        days === 0 &&
        (
            target.getHours() > CONFIG.countdownHour ||
            (
                target.getHours() === CONFIG.countdownHour &&
                target.getMinutes() >= CONFIG.countdownMinute
            )
        )
    ) {
        days = 7;
    }

    target.setDate(target.getDate() + days);

    target.setHours(
        CONFIG.countdownHour,
        CONFIG.countdownMinute,
        CONFIG.countdownSecond,
        0
    );

    return target;

}

function stockWidth(quantity) {

    quantity = Number(quantity || 0);

    if (quantity <= CONFIG.stock.low) {
        return 20;
    }

    if (quantity <= CONFIG.stock.medium) {
        return 45;
    }

    if (quantity <= CONFIG.stock.high) {
        return 70;
    }

    return 100;

}

function calculateDiscount(compareAtPrice, price) {

    compareAtPrice = Number(compareAtPrice || 0);
    price = Number(price || 0);

    if (compareAtPrice <= price) {
        return 0;
    }

    return Math.round(
        ((compareAtPrice - price) / compareAtPrice) * 100
    );

}

/*====================================================
=            REGISTRO GLOBAL                          =
====================================================*/

const registry = {

    cards: new Set(),

    timer: null,

    initialized: false

};

/*====================================================
=            CLASE OFFERCARD                          =
====================================================*/

class OfferCard {

    constructor(box) {

        this.box = box;

        this.productInfo =
            box.closest("product-info");

        this.product =
            box.closest(".product");

        this.section =
            box.closest("[data-section]");

        this.variantInput =
            this.productInfo?.querySelector('input[name="id"]') ||
            this.product?.querySelector('input[name="id"]');

        this.variantJSON =
            this.productInfo?.querySelector(".aa-variants-json") ||
            this.product?.querySelector(".aa-variants-json");

        this.variants = [];

        this.variant = null;

        this.cache();

        this.loadVariants();

        this.bind();

        registry.cards.add(this);

    }

    /*==============================================*/

    cache() {

        this.price =
            this.box.querySelector(".aa-price");

        this.oldPrice =
            this.box.querySelector(".aa-old-price");

        this.discount =
            this.box.querySelector(".aa-discount");

        this.stockFill =
            this.box.querySelector(".aa-stock-fill");

        this.stockText =
            this.box.querySelector(".aa-stock-text");

        this.days =
            this.box.querySelector(".aa-days");

        this.hours =
            this.box.querySelector(".aa-hours");

        this.minutes =
            this.box.querySelector(".aa-minutes");

        this.seconds =
            this.box.querySelector(".aa-seconds");

    }

    /*==============================================*/

    loadVariants() {

        if (!this.variantJSON) {

            console.warn(
                "OfferCard: JSON de variantes no encontrado."
            );

            return;

        }

        try {

            this.variants = JSON.parse(
                this.variantJSON.textContent
            );

        }

        catch (error) {

            console.error(
                "OfferCard: Error leyendo JSON",
                error
            );

            this.variants = [];

        }

    }

    /*==============================================*/

    bind() {

        if (!this.variantInput) return;

        this.renderById(
            this.variantInput.value
        );

        this.variantInput.addEventListener(
            "change",
            () => {

                this.renderById(
                    this.variantInput.value
                );

            }
        );

    }

    /*==============================================*/

    getVariant(id) {

        id = String(id);

        return this.variants.find(

            variant =>

                String(variant.id) === id

        );

    }

    /*==============================================*/

    renderById(id) {

        const variant =
            this.getVariant(id);

        if (!variant) return;

        this.render(variant);

    }

    /*==============================================*/

    show() {

        this.box.classList.remove(
            "aa-hidden"
        );

    }

    hide() {

        this.box.classList.add(
            "aa-hidden"
        );

    }


        /*==============================================*/
    /*                RENDER PRINCIPAL               */
    /*==============================================*/

    render(variant) {

        this.variant = variant;

        const hasOffer =
            Number(variant.compare_at_price || 0) >
            Number(variant.price || 0);

        if (hasOffer) {
            this.show();
        } else {
            this.hide();
        }

        this.updatePrice();
        this.updateDiscount();
        this.updateStock();
        this.syncNativePrice();

    }

    /*==============================================*/
    /*               PRECIO ACTUAL                   */
    /*==============================================*/

    updatePrice() {

        if (!this.variant) return;

        if (this.price) {

            this.price.textContent =
                money(this.variant.price);

        }

        if (this.oldPrice) {

            if (
                this.variant.compare_at_price >
                this.variant.price
            ) {

                this.oldPrice.textContent =
                    money(
                        this.variant.compare_at_price
                    );

                this.oldPrice.style.display = "";

            } else {

                this.oldPrice.style.display = "none";

            }

        }

    }

    /*==============================================*/
    /*                 DESCUENTO                     */
    /*==============================================*/

    updateDiscount() {

        if (!this.variant) return;

        if (!this.discount) return;

        const percent = calculateDiscount(

            this.variant.compare_at_price,

            this.variant.price

        );

        if (percent <= 0) {

            this.discount.style.display = "none";

            return;

        }

        this.discount.style.display = "";

        this.discount.textContent =
            percent + "% OFF";

    }

    /*==============================================*/
    /*          OCULTAR PRECIO NATIVO DAWN           */
    /*==============================================*/

    syncNativePrice() {

        const nativePrice =

            this.productInfo?.querySelector('[id^="price-"]') ||

            this.product?.querySelector('[id^="price-"]');

        if (!nativePrice) return;

        if (
            this.variant &&
            this.variant.compare_at_price >
            this.variant.price
        ) {

            nativePrice.classList.add(
                "aa-hidden-price"
            );

        } else {

            nativePrice.classList.remove(
                "aa-hidden-price"
            );

        }

    }

        /*==============================================*/
    /*                INVENTARIO                     */
    /*==============================================*/

    updateStock() {

        if (!this.variant) return;

        const quantity = Number(
            this.variant.inventory_quantity || 0
        );

        const managed =
            this.variant.inventory_management;

        const policy =
            this.variant.inventory_policy;

        if (!this.stockFill && !this.stockText) return;

        /*------------------------------------------
        | Productos sin control de inventario
        ------------------------------------------*/

        if (!managed) {

            if (this.stockText) {
                this.stockText.textContent =
                    "✔ Disponible";
            }

            if (this.stockFill) {
                this.stockFill.style.width = "100%";
                this.stockFill.style.background = "#22c55e";
            }

            return;

        }

        /*------------------------------------------
        | Sin stock pero continúa vendiendo
        ------------------------------------------*/

        if (
            quantity <= 0 &&
            policy === "continue"
        ) {

            if (this.stockText) {
                this.stockText.textContent =
                    "✔ Disponible";
            }

            if (this.stockFill) {
                this.stockFill.style.width = "100%";
                this.stockFill.style.background = "#22c55e";
            }

            return;

        }

        /*------------------------------------------
        | Agotado
        ------------------------------------------*/

        if (quantity <= 0) {

            if (this.stockText) {
                this.stockText.textContent =
                    "❌ Agotado";
            }

            if (this.stockFill) {
                this.stockFill.style.width = "0%";
                this.stockFill.style.background = "#ef4444";
            }

            return;

        }

        /*------------------------------------------
        | Disponible
        ------------------------------------------*/

        if (this.stockText) {

            this.stockText.textContent =
                "🔥 Últimas " +
                quantity +
                " unidades";

        }

        if (this.stockFill) {

            this.stockFill.style.width =
                stockWidth(quantity) + "%";

            if (quantity <= 5) {

                this.stockFill.style.background =
                    "#ef4444";

            }

            else if (quantity <= 10) {

                this.stockFill.style.background =
                    "#f97316";

            }

            else {

                this.stockFill.style.background =
                    "#22c55e";

            }

        }

    }

    /*==============================================*/
    /*                CONTADOR                       */
    /*==============================================*/

    updateCountdown(now, target) {

        const distance =
            Math.max(
                0,
                target.getTime() - now.getTime()
            );

        const days =
            Math.floor(distance / 86400000);

        const hours =
            Math.floor(
                (distance % 86400000) /
                3600000
            );

        const minutes =
            Math.floor(
                (distance % 3600000) /
                60000
            );

        const seconds =
            Math.floor(
                (distance % 60000) /
                1000
            );

        if (this.days) {
            this.days.textContent =
                String(days).padStart(2, "0");
        }

        if (this.hours) {
            this.hours.textContent =
                String(hours).padStart(2, "0");
        }

        if (this.minutes) {
            this.minutes.textContent =
                String(minutes).padStart(2, "0");
        }

        if (this.seconds) {
            this.seconds.textContent =
                String(seconds).padStart(2, "0");
        }

    }

    /*==============================================*/
    /*               LIMPIEZA                        */
    /*==============================================*/

    destroy() {

        registry.cards.delete(this);

    }

}

/*====================================================
=            FIN DE OFFERCARD                         =
====================================================*/

/*====================================================
=            OFFER MANAGER                           =
====================================================*/

class OfferManager {

    constructor() {

        this.started = false;

        this.init();

    }

    /*==============================================*/

    init() {

        this.initCards();

        this.startTimer();

        this.started = true;

    }

    /*==============================================*/

    initCards(root = document) {

        const boxes =
            root.querySelectorAll(".aa-offer-box");

        boxes.forEach(box => {

            if (box.__offerInitialized) {
                return;
            }

            box.__offerInitialized = true;

            box.__offerCard = new OfferCard(box);

        });

    }

    /*==============================================*/

    startTimer() {

        if (registry.timer) {
            return;
        }

        const update = () => {

            const now = chileNow();

            const target = nextSunday();

            registry.cards.forEach(card => {

                card.updateCountdown(
                    now,
                    target
                );

            });

        };

        update();

        registry.timer = window.setInterval(
            update,
            1000
        );

    }

    /*==============================================*/

    refresh(root = document) {

        this.initCards(root);

    }

    /*==============================================*/

    destroy() {

        if (registry.timer) {

            clearInterval(
                registry.timer
            );

            registry.timer = null;

        }

        registry.cards.forEach(card => {

            card.destroy();

        });

        registry.cards.clear();

    }

}

/*====================================================
=            INICIALIZACIÓN GLOBAL                    =
====================================================*/

let manager = null;

function initOfferSystem(root = document) {

    if (!manager) {

        manager = new OfferManager();

    }

    manager.refresh(root);

}

/*==============================================
= DOM Ready
==============================================*/

if (document.readyState === "loading") {

    document.addEventListener(
        "DOMContentLoaded",
        () => initOfferSystem()
    );

} else {

    initOfferSystem();

}

/*==============================================
= Shopify Theme Editor
==============================================*/

document.addEventListener(
    "shopify:section:load",
    e => manager?.refresh(e.target)
);

document.addEventListener(
    "shopify:section:select",
    e => manager?.refresh(e.target)
);

document.addEventListener(
    "shopify:section:reorder",
    () => manager?.refresh()
);

document.addEventListener(
    "quickadd:loaded",
    e => manager?.refresh(e.target)
);

document.addEventListener(
    "artesania:product-loaded",
    e => manager?.refresh(e.target)
);

/*==============================================
= Dawn Variant Change
==============================================*/

if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
) {

    subscribe(
        PUB_SUB_EVENTS.variantChange,
        ({ data }) => {

            if (!data?.variant) return;

            registry.cards.forEach(card => {

                if (
                    String(card.variant?.id) !==
                    String(data.variant.id)
                ) {

                    if (
                        card.variantInput &&
                        String(card.variantInput.value) ===
                        String(data.variant.id)
                    ) {

                        card.renderById(
                            data.variant.id
                        );

                    }

                }

            });

        }
    );

}

/*====================================================
=            FIN DEL ARCHIVO                         =
====================================================*/

})();

document.addEventListener('variant:change',()=>window.dispatchEvent(new Event('resize')));
document.addEventListener('product-info:loaded',()=>window.dispatchEvent(new Event('resize')));
